import { render } from "./FormManterCalculoSituacao.vue?vue&type=template&id=f5037cf8"
import script from "./FormManterCalculoSituacao.vue?vue&type=script&lang=js"
export * from "./FormManterCalculoSituacao.vue?vue&type=script&lang=js"

import "./FormManterCalculoSituacao.vue?vue&type=style&index=0&id=f5037cf8&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__